import { render, staticRenderFns } from "./DcInfobox.vue?vue&type=template&id=cb03f804&scoped=true&"
import script from "./DcInfobox.vue?vue&type=script&lang=ts&"
export * from "./DcInfobox.vue?vue&type=script&lang=ts&"
import style0 from "./DcInfobox.vue?vue&type=style&index=0&id=cb03f804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb03f804",
  null
  
)

component.options.__file = "DcInfobox.vue"
export default component.exports